import { StyledFlex } from '@dreryk/react-components';

import { InvoiceFiscalPrintIntegration } from './InvoiceFiscalPrintIntegration';
import { InvoicePanelLoader } from './InvoicePanel.loader';
import { InvoicePanelBanner } from './InvoicePanelBanner';
import { InvoiceProviderAccountDetails } from './InvoiceProviderAccountDetails';

export const InvoicePanel = (): JSX.Element => {
   return (
      <InvoicePanelLoader>
         {({ invoiceOfferUrl, currentInvoiceProviderAccountInfo }) =>
            currentInvoiceProviderAccountInfo ? (
               <StyledFlex direction={'column'} gap={24}>
                  <InvoiceProviderAccountDetails
                     currentInvoiceProviderAccountInfo={currentInvoiceProviderAccountInfo}
                     invoiceOfferUrl={invoiceOfferUrl}
                  />
                  <InvoiceFiscalPrintIntegration />
               </StyledFlex>
            ) : (
               <InvoicePanelBanner invoiceOfferUrl={invoiceOfferUrl} />
            )
         }
      </InvoicePanelLoader>
   );
};
